require('./app').app.$mount('#app')



// WEBPACK FOOTER //
// ./src/entry.client.js